<template>
  <!--仅当业务类型为Hyperlocal Apartment时（businessType === 700）是需要显示填写填写-->
  <div v-if="isDine && isApartment" class="apart">
    <div class="apart-item">
      <div class="label">
        {{ $t('checkout.selectApartUnitLabel') }} <b>*</b>
        <MTooltip :text="$t('checkout.selectApartTips')">
          <q-icon name="app:tipsIcon" class="logo" size="16px" />
        </MTooltip>
      </div>
      <div class="apart-item-select" @click.stop="show = !show">
        <input
          v-model="keyword"
          type="text"
          :placeholder="$t('checkout.selectApartUnit')"
          @click.stop
          @focus="show = true"
        />
        <q-icon
          class="icon"
          :name="`svg:Chevron${show ? 'Top' : 'Down'}`"
          size="20"
        />
        <div v-show="show" class="item-options">
          <div
            v-for="item of filterApart"
            :key="item"
            class="item"
            @click.stop="onChoose(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div class="apart-item">
      <div class="label">{{ $t('common.details') }}<b>*</b></div>
      <q-input
        v-model="form.apartmentAddressDetail"
        :placeholder="$t('checkout.inputApartDetail')"
        :maxlength="30"
        class="apart-item-input"
        outlined
        no-error-icon
        hide-bottom-space
        bg-color="white"
      >
        <template #append>
          <span
            :style="{
              'font-size': '12px',
              color:
                form.apartmentAddressDetail.length >= 30
                  ? '#EF4444'
                  : '#6B7280',
            }"
          >
            {{ form.apartmentAddressDetail.length }} / 30
          </span>
        </template>
      </q-input>
    </div>
  </div>
</template>

<script>
import { getTableNumber, getApartAddrs } from 'src/api/checkout';
import MTooltip from 'src/components/MTooltip.vue';
import { maskClick } from '../../../mixin/maskClick';

export default {
  components: { MTooltip },
  mixins: [maskClick('show')],
  data() {
    return {
      apartListCluster: [],
      show: false,
      keyword: '',
      form: {
        apartmentAddress: '',
        apartmentAddressDetail: '',
      },
    };
  },
  computed: {
    filterApart() {
      return this.apartListCluster.filter(
        it => it.toUpperCase().indexOf(this.keyword.toUpperCase()) !== -1,
      );
    },
  },
  watch: {
    keyword(v) {
      const include = this.apartListCluster.indexOf(v) !== -1;
      this.form.apartmentAddress = include ? `${v}` : '';
    },
    form: {
      handler() {
        this.$emit('change', this.onValid());
      },
      deep: true,
    },
  },
  mounted() {
    this.loadOption();
  },
  methods: {
    onChoose(item) {
      this.form.apartmentAddress = `${item}`;
      this.keyword = item;
      this.show = false;
    },
    onValid() {
      return {
        valid:
          !!this.form.apartmentAddress.trim() &&
          !!this.form.apartmentAddressDetail.trim(),
        ...this.form,
      };
    },
    loadOption() {
      getApartAddrs().then(res => {
        if (res.code === 200) {
          this.apartListCluster = res.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.apart {
  padding: 16px 16px;
  &-item {
    & + .apart-item {
      margin-top: 16px;
    }
    .label {
      font-weight: 800;
      font-size: 12px;
      padding-bottom: 8px;
      b {
        color: red;
        padding: 0 6px 0 2px;
      }
    }
  }
  &-item-input {
    :deep(.q-field__control) {
      box-shadow: none !important;
      height: 42px;
      border-radius: 8px;
      input::-webkit-input-placeholder {
        color: #6b7280;
      }
    }
    :deep(.q-field__append) {
      height: 42px;
      line-height: 42px;
    }
  }
  &-item-select {
    height: 42px;
    border: solid 1px #c2c2c2;
    width: 100%;
    border-radius: 8px;
    padding: 0 34px 0 14px;
    position: relative;
    & > p {
      line-height: 42px;
    }
    .icon {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
    }
    .item-options {
      position: absolute;
      top: 120%;
      left: 0;
      width: 100%;
      width: 100%;
      min-height: 50px;
      max-height: 300px;
      background: #fff;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      z-index: 10;
      padding: 0 16px;
      overflow-y: scroll;
      .item {
        width: 100%;
        text-align: center;
        line-height: 50px;
        font-size: 14px;
        & + .item {
          border-top: 1px solid #f3f4f6;
        }
      }
    }
    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
    }
  }
}
</style>
